import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  agreementText: {
    fontSize: '0.9rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    textAlign: 'justify',
  },
  agreementLabelDisabled: {
    opacity: 0.5,
  },
  desktopSummaryCheckbox: {
    display: 'flex',
    marginTop: 20,
  },
  agreementTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
}));

export default useStyles;
